const types = {
    SET_USERS: '[CASHIER] SET USERS',
    SET_GROUPS: '[CASHIER] SET GROUPS',
}

export {
    types,
}